import MultiSelectCheckbox from "../../common/components/MultiSelectCheckbox";
import * as actions from "./../../common/actions";
import { StoreState } from "./../../common/types/index";
import { connect } from "react-redux";
import { Dispatch } from "redux";

export function mapStateToProps({ query }: StoreState.All, ownProps: any) {
  return {
    selectedValues: query.filters[ownProps.filterName],
  };
}

export function mapDispatchToProps(
  dispatch: Dispatch<actions.AllActions>,
  ownProps: any,
) {
  return {
    onAdd: (values: any) =>
      dispatch(actions.addToMultiFilter(ownProps.filterName, values)),
    onRemove: (values: any) =>
      dispatch(actions.removeFromMultiFilter(ownProps.filterName, values)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultiSelectCheckbox);
